import { IconEmphasis } from '@xing-com/icons';

import * as Styled from '../styles';
import { type ToolProps } from '../types';

export const EmphasisTool: React.FC<ToolProps> = ({ editor, disabled }) => {
  return (
    <Styled.ToolBarButton
      onClick={() => editor.chain().focus().toggleBlockquote().run()}
      disabled={
        disabled || !editor.can().chain().focus().toggleBlockquote().run()
      }
      className={editor.isActive('blockquote') ? 'is-active' : ''}
    >
      <IconEmphasis width={24} height={24} />
    </Styled.ToolBarButton>
  );
};
